import classNames from 'clsx';
import type React from 'react';
import type { PropsWithChildren } from 'react';

import styles from '../../sharedStyles/RawInput.module.scss';
import type { Props } from '../Toggle/Toggle';

export type ToggleGroupProps = PropsWithChildren & {
  id: string;
  label: React.ReactNode;
  labelInfo?: React.ReactNode;
  labelClassName?: string;
  name?: string;
  type?: Props['type'];
  className?: string;
};

const ToggleGroup: React.FC<ToggleGroupProps> = ({
  labelClassName,
  id,
  label,
  labelInfo,
  className,
  children
}) => (
  <>
    <label className={labelClassName} htmlFor={id}>
      {label}
      {labelInfo}
    </label>
    <div className={classNames(styles.inputWrapper, className)}>{children}</div>
  </>
);

export default ToggleGroup;
